export { default as useCookieConsent } from './useCookieConsent';
